"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * get unique Array
 * @param {Array} input
 * @returns {Array}
 */
// comment for publish package.
function getUniqueArray(input) {
  return input.filter(function (item, index, arr) {
    return arr.indexOf(item) === index;
  });
}
var _default = exports["default"] = getUniqueArray;